import { AxiosResponse } from "axios";
import { ApiResponse, ApiResponseGrid } from "middleware/api";
import { actions } from "reducers/slotTemplates";
import * as regionsMiddleware from "middleware/regions";
import * as slotsMiddleware from "middleware/slots";
import { actions as notificationActions } from "../reducers/notification";
import {
  call,
  CallEffect,
  ForkEffect,
  put,
  PutEffect,
  takeLatest,
} from "redux-saga/effects";
import {
  RegionsResponseType,
  WorkzonesResponseType,
  RegionType,
} from "./types/regions";
import { PayloadAction } from "@reduxjs/toolkit";
import {
  SlotsTemplatesRequestParamsType,
  SlotTemplatesFilterType,
} from "reducers/types/slotTemplates";
import { SlotTemplateType } from "./types/slotTemplates";
import { serverErrorAlert } from "utils/alerts";

const sagas: ForkEffect<never>[] = [
  takeLatest(actions.getRegionsRequest.type, getRegions),
  takeLatest(actions.getWorkzonesFetch.type, getWorkzones),
  takeLatest(actions.getSlotTemplatesRequest.type, getTemplates),
];

export default sagas;

function* getRegions(): Generator<
  | PutEffect<{ payload: undefined; type: string }>
  | PutEffect<{ payload: RegionType[]; type: string }>
  | CallEffect<AxiosResponse<ApiResponse<RegionsResponseType>>>,
  void,
  ApiResponse<RegionsResponseType>
> {
  const response = yield call(regionsMiddleware.getRegions);
  if (response.status !== 200) {
    yield put(actions.getRegionsError());
  } else {
    const { result } = response.data;
    yield put(actions.getRegionsSuccess(result.items));
  }
}

function* getWorkzones({
  payload,
}: PayloadAction<string>): Generator<
  | PutEffect<{ type: string }>
  | CallEffect<AxiosResponse<ApiResponse<WorkzonesResponseType>>>,
  void,
  ApiResponse<WorkzonesResponseType>
> {
  const response = yield call(regionsMiddleware.getWorkzonesByRegion, payload);
  if (response.status !== 200) {
    yield put(actions.getWorkzonesError());
  } else {
    const { result } = response.data;
    yield put(actions.getWorkzonesSuccess(result.items));
  }
}

function* getTemplates({
  payload,
}: PayloadAction<SlotTemplatesFilterType>): Generator<
  | CallEffect<AxiosResponse<ApiResponseGrid<SlotTemplateType>>>
  | PutEffect<{ type: string }>,
  void,
  ApiResponse<ApiResponseGrid<SlotTemplateType>>
> {
  const params: SlotsTemplatesRequestParamsType = {
    code: payload?.code || undefined,
    regionId: payload.region || undefined,
    workZones: payload.workzone || undefined,
    type: payload?.shift|| undefined,
    days: payload?.days || undefined,
    limit: payload.limit,
    offset: payload.offset,
  };
  const response = yield call(slotsMiddleware.getSlotTemplates, params);
  if (response.status !== 200) {
    yield put(notificationActions.showNotification(serverErrorAlert()));
    yield put(actions.getSlotTemplatesError());
  } else {
    yield put(actions.getSlotTemplatesSuccess(response.data));
  }
}
